import { DateTime } from 'luxon';
/** Display form of an exact `YYYY-MM-DD` date, e.g. `5 Nov 2026`. */
export const formatBillingDate = (date) => DateTime.fromISO(date, { zone: 'utc' }).toFormat('d MMM yyyy');
/** The current billable year as **exact** dates (end exclusive) — the real
 * enable date advanced by whole years. This is the accounting window: usage is
 * summed over `[start, end)`. It keeps the enable day-of-month so the UI can
 * show "5 Nov 2025 – 5 Nov 2026", and rolls over on the exact anniversary day
 * (not the anniversary month): the window advances only once `now` reaches the
 * next anniversary. */
export const currentBillableYear = (enableDate, now = DateTime.utc()) => {
    const enable = DateTime.fromISO(enableDate, { zone: 'utc' }).startOf('day');
    const nowMs = now.toUTC().toMillis();
    // Roll on the exact anniversary day, not the anniversary month: advance while
    // the next anniversary has already arrived. (luxon clamps e.g. Feb 29 → 28.)
    let years = 0;
    while (enable.plus({ years: years + 1 }).toMillis() <= nowMs)
        years += 1;
    const start = enable.plus({ years });
    return {
        start: start.toISODate(),
        end: start.plus({ years: 1 }).toISODate(),
    };
};
//# sourceMappingURL=billableYear.js.map